// Follow Mixpanel event naming conventions: https://www.notion.so/sparelabs/Mixpanel-Naming-Conventions-ff32a1723bcd42aba4ae46bf2542763b
export enum EventName {
  AppLoad = 'app_load',
  ExpoUpdateStatus = 'expo_update_status',
  ContinueJourney = '*Press* RiderApp | ContinueJourney-Button',
  JourneyRequestRide = '*Press* RiderApp | JourneyRequestRide-Button',
  ScreenView = 'screen_view',
}
